import React, { useState } from 'react';

const VirtualKeyboard = ({ onKeyPress, onClose, isVisible, position }) => {
  const [shift, setShift] = useState(false);

  const keys = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/'],
    ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')'],
    ['-', '_', '+', '=', '[', ']', '{', '}', '|', '\\'],
    [';', ':', "'", '"', '<', '>', '?', '~', '`'],
    ['Backspace', 'Space', 'Capslock']
  ];

  const handleKeyClick = (key) => {
    if (key === 'Backspace') {
      onKeyPress('backspace');
    } else if (key === 'Space') {
      onKeyPress(' ');  // Fixed: Explicit space string
    } else if (key === 'Capslock') {
      setShift(!shift);
    } else {
      onKeyPress(shift ? key.toUpperCase() : key);
    }
  };

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,  // Bottom of page
      left: 0,
      right: 0,
      transform: 'none',  // Remove center transform
      width: '100%',  // Full width
      maxWidth: 'none',  // No cap for bottom placement
      backgroundColor: '#000',
      padding: '8px',
      borderTopLeftRadius: '8px',  // Rounded top corners for attractive blend
      borderTopRightRadius: '8px',
      boxShadow: '0 -2px 10px #7e006dff',  // Shadow from bottom
      zIndex: 1000,
      transition: 'opacity 0.3s ease-in-out',
      opacity: isVisible ? 1 : 0,
    }}>
      <button onClick={onClose} style={{
        position: 'absolute',
        top: '-25px',  // Outside top
        right: '10px',  // Inside right for bottom keyboard
        backgroundColor: '#380031ff',
        color: '#ff00ddff',
        border: 'none',
        borderRadius: '50%',
        width: '30px',
        height: '30px',
        fontSize: '20px',
        cursor: 'pointer',
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)',
        transition: 'background-color 0.2s ease-in-out',
      }}
      onMouseDown={(e) => e.preventDefault()}>×</button>
      {keys.map((row, i) => (
        <div key={i} style={{ display: 'flex', justifyContent: 'center', gap: '3px', marginBottom: '3px' }}>
          {row.map((key) => (
            <button key={key} onClick={() => handleKeyClick(key)} style={{
              backgroundColor: '#222',
              color: '#fff',
              border: '1px solid #7e006dff',
              borderRadius: '4px',
              padding: '8px',
              fontSize: '16px',
              flex: 1,  // Even full-width distribution
              cursor: 'pointer',
              transition: 'background-color 0.2s ease-in-out, transform 0.2s ease-in-out',
            }}
            onMouseDown={(e) => e.preventDefault()}>
              {shift && /^[a-z]$/.test(key) ? key.toUpperCase() : key}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
};

export default VirtualKeyboard;
